import * as Routes from 'constants/Routes'

// Pages that work without a session: public links, the login and sign up
// flows, and the legal pages.
const PUBLIC_ROUTES = [
  Routes.CHANNEL,
  Routes.LOGIN,
  Routes.FULLSCREEN_LINK,
  Routes.FORGOTTEN_PASSWORD,
  Routes.CONFIRM_USER,
  Routes.RECOVER_PASSWORD,
  Routes.CONFIRM_RECIPIENT,
  Routes.CONFIRM_TRUSTED_USER,
  Routes.CHECK_TRUSTED_USER_STATUS,
  Routes.SIGN_UP_TRUSTED_USER,
  Routes.POLICY,
  Routes.TERMS,
  Routes.COOKIES,
  Routes.MANAGE_COOKIES
]

/**
 * Tells if a page works without a session.
 *
 * Only the first part of the path counts, so '/channel/123' is public and a
 * page such as '/projects/login-help' is not. This list also decides whether
 * a request sends the token, so a loose match would be risky.
 *
 * @param {string} pathname - The path of the page, such as '/channel/123'.
 * @returns {boolean} True on a public page.
 */
export const isPublicPath = pathname => {
  const firstSegment = `/${pathname.split('/')[1] || ''}`

  return PUBLIC_ROUTES.includes(firstSegment)
}
